export const UPDATE_ORDER_STATUS_WIDGET = "UPDATE_ORDER_STATUS_WIDGET";